const MAX_RETRIES = 5;
const RETRY_DELAY = 3000;

/** Call request, retrying up to `retries` more times on failure with an increasing delay */
const withRetry = async (request, retries = MAX_RETRIES, attempt = 1) => {
  try {
    return await request();
  } catch (err) {
    if (attempt > retries) throw err;
    await new Promise((resolve) => setTimeout(resolve, RETRY_DELAY * attempt));
    return withRetry(request, retries, attempt + 1);
  }
};

export default withRetry;
